<template>
  <spaceduck-collapse class="filter-collapse-general"
                      :id="`filter-collapse-${viewModel}`"
                      :visible="visible">
    <div class="pb-md-4 filter-wrapper-pb">
      <div class="filter-wrapper">
        <a class="filter-wrapper-close"
           ref="filter-wrapper-close"
           v-spaceduck-collapse="`filter-collapse-${viewModel}`">
          <CloseSvg/><span class="d-md-none d-inline">{{ $t('filter') }}</span>
        </a>
        <div class="row no-gutters">
          <div class="order-md-0 order-1 no-print col-12">
            <div class="row align-items-center">
              <div class="order-md-0 order-2 col-12 col-md-auto">
                <button class="btn btn-themed d-md-inline-flex d-flex refresh-btn align-items-center"
                        id="btn-filter-refresh"
                        @click="refresh">
                  <RefreshSvg class="mr-2"/>
                  {{ $t('refresh') }}
                </button>
              </div>
              <div class="order-md-1 order-0 mt-md-0 mt-3 col-12 col-md-auto">
                <a class="a-themed"
                   @click="addCondition">
                  <PlusSvg class="mr-2 d-inline-block align-middle"/>
                  <span class="d-inline-block align-middle">
                    {{ $t('add_condition') }}
                  </span>
                </a>
              </div>
              <div class="order-md-2 order-1 mt-md-0 mt-3 col-12 col-md-auto" v-if="$route.name === 'MarketingGroup'">
                <a class="a-themed"
                   @click="saveFilter">
                  <FloppySvg class="mr-2 d-inline-block align-middle"/>
                  <span class="d-inline-block align-middle">{{ $t('save_filter') }}</span>
                </a>
              </div>
            </div>
          </div>
          <div class="order-md-1 order-0 col-12">
            <div class="row">
              <div v-for="f in filters"
                   class="mt-3 col-12 col-md-auto"
                   :key="`filter-selected-${f.id}`">
                <div class="filter-field">
                  <div class="row no-gutters align-items-center">
                    <div class="col-auto col-md-auto">
                      <div class="filter-title">{{ $t(f.title) }}:</div>
                    </div>
                    <div class="col col-auto">
                      <select v-model="f.ctype" class="select-type">
                        <option v-for="o in getCTypes(f.type, f.id)"
                                :value="o.id"
                                :key="`ctype-${f.id}-${o.id}`">
                          {{ $t(o.title) }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-auto col">
                      <div v-if="['select', 'select_equals', 'select_multiple'].includes(f.type)"
                           class="filter-value">
                        <select v-model="f.condition"
                                :multiple="['contains', 'does_not_contain'].includes(f.ctype)">
                          <option value="">{{ $t('select') }}</option>
                          <option v-for="o in f.options"
                                  :key="`cond-${f.id}-${o.id}`"
                                  :value="o.id">
                            {{ f.translate ? $t(o.title) : (o.title || o.full_name) }}
                          </option>
                        </select>
                      </div>
                      <div v-else-if="f.type === 'boolean' || f.ctype === 'filled'"
                           class="filter-value">
                        <select v-model="f.condition">
                          <option value="0">{{ $t('no') }}</option>
                          <option value="1">{{ $t('yes') }}</option>
                        </select>
                      </div>
                      <div v-else-if="f.type === 'date' || f.type === 'date_with_interval'">
                        <DateGroup
                            class="simple-input d-inline-block"
                            :showlabel="false"
                            :calendarIcon="false"
                            v-model="f.condition"/>
                        <DateGroup
                            v-if="f.ctype === 'interval'"
                            class="simple-input d-inline-block"
                            :showlabel="false"
                            :calendarIcon="false"
                            v-model="f.conditionAdd"/>
                      </div>
                      <div v-else-if="f.type === 'date_with_interval_no_year'">
                        <MonthDayGroup v-model="f.condition"/>
                        <span v-if="f.ctype === 'interval'" class="mx-2">-</span>
                        <MonthDayGroup
                            v-if="f.ctype === 'interval'"
                            class="ml-2"
                            v-model="f.conditionAdd"/>
                      </div>
                      <TimeGroup v-else-if="f.type === 'time'"
                                 class="simple-input"
                                 :showlabel="false"
                                 :calendarIcon="false"
                                 v-model="f.condition"/>
                      <div v-else-if="f.type === 'text_with_interval' || f.type === 'number_with_interval'">
                        <input @keyup.enter="refresh"
                               :class="{ underlined: f.ctype === 'interval' }"
                               :type="f.type === 'number_with_interval' ? 'number' : 'text'"
                               v-model="f.condition"/>
                        <input v-if="f.ctype === 'interval'"
                               class="underlined mx-2"
                               :type="f.type === 'number_with_interval' ? 'number' : 'text'"
                               @keyup.enter="refresh"
                               v-model="f.conditionAdd"/>
                      </div>
                      <div v-else-if="f.type === 'service'">
                        <a @click="showServiceSelect" class="pointer text-black">
                          <span v-if="!f.condition || !f.condition.length">{{ $t('select_from_price') }}</span>
                          <span v-for="(serId, index) in f.condition"
                                :key="`service-filter-title-${serId}`">
                            <span v-if="index > 0">, </span>
                            {{ f.additionalData && f.additionalData[index] ? (f.additionalData[index].title || `${$t('service')} id ${serId}`) : `${$t('service')} id ${serId}` }}
                          </span>
                          <!--                          {{ f.condition ? (f.additionalData ? f.additionalData.title : `${$t('service')} id ${f.condition}`) : $t('select_from_price') }}-->
                        </a>
                      </div>
                      <input v-else
                             @keyup.enter="refresh"
                             v-model="f.condition"/>
                    </div>
                    <div class="col col-auto">
                      <a class="filter-close"
                         @click="removeFilter(f.id)">
                        <CloseSvg/>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal :id="`filter-modal-${viewModel}`"
             :title="$t('filter')"
             hide-footer>
      <template v-for="f in options.fields">
        <a class="option-list-item"
           :key="`filter-option-${f.id}`"
           @click="filterSelected(f)"
           v-if="f.filter && !filters[f.id] && !f.filter_hidden">
          {{ $t(f.title) }}
        </a>
      </template>
    </b-modal>

    <ServicesFromPriceBlock :show-toggle="false"
                            :multipleSelection="true"
                            ref="serviceSelect"
                            :pre-selected="filters.service ? filters.service.condition : []"
                            @selected="servicesSelected"/>

  </spaceduck-collapse>
</template>

<script>

import { mapState } from "vuex"
import RefreshSvg from '@/assets/svg-vue/general/refresh.svg'
import FloppySvg from '@/assets/svg-vue/general/floppy.svg'
import PlusSvg from '@/assets/svg-vue/header/plus.svg'
import CloseSvg from '@/assets/svg-vue/general/close.svg'
import { EloquentService } from "@/services/api/eloquent.api.service"
import DateGroup from "@/components/form/DateGroup"
import TimeGroup from "@/components/form/TimeGroup.vue"
import MonthDayGroup from "@/components/form/MonthDayGroup.vue"
import SpaceduckCollapse from "@/components/parts/general/SpaceduckCollapse.vue"
import ServicesFromPriceBlock from "@/components/parts/patients/ServicesFromPriceBlock.vue"

export default {
  name: "DataTableFilter",
  components: {
    ServicesFromPriceBlock,
    TimeGroup,
    DateGroup,
    MonthDayGroup,
    RefreshSvg,
    PlusSvg,
    CloseSvg,
    FloppySvg,
    SpaceduckCollapse
  },
  emits: ['filterReady'],
  props: {
    options: {
      type: Object
    },
    cacheId: {
      type: String,
      default: null
    },
    considerInitialFilters: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      filters: {},
      prepared: false,
      visible: false,
    }
  },
  computed: {
    ...mapState({
      viewModel: state => state.datatable.viewModel,
      selectModels: state => state.datatable.selectModels,
      filtersCache: state => state.datatable.filtersCache,
      superadmin: state => state.auth.superadmin,
    }),
    hasInitialFilters() {
      // return !!this.$route.query.filters
      return this.$route.query.filters && this.$route.query.filters != '{}' && this.considerInitialFilters
    },
    filterCached() {
      return this.filtersCache[this.cacheKey] ?? null
    },
    routeName() {
      return this.$route.name
    },
    cacheKey() {
      return this.cacheId || this.$route.name
    }
  },
  watch: {
    viewModel: {
      handler(val) {
        this.$nextTick(() => { // to allow for spaceduck collapse get new viewModel, this way it saves correct settings (not of previous viewModel)
          if(val) {
            this.visible = false // we assume it's new page and we don't show filter opened for new page by default, even if some filters were set from cache or link
            if(this.hasInitialFilters || (this.filterCached && Object.keys(this.filterCached).length > 0)) {
              this.prepare().then(() => {
                let routeFilters
                if(this.hasInitialFilters) {
                  routeFilters = JSON.parse(this.$route.query.filters)
                } else {
                  routeFilters = this.filterCached
                }
                for(let r in routeFilters) {
                  this.options.fields.forEach(item => {
                    if(item.id == r) {
                      this.filterSelected(
                          item,
                          routeFilters[r].condition,
                          routeFilters[r].conditionAdd,
                          routeFilters[r].type
                      )
                    }
                  })
                }
                this.filtersToData()
                this.$emit('filterReady', true)
              })
            } else {
              this.$emit('filterReady')
            }
          }
        })
      },
      immediate: true
    },
  },
  methods: {
    refresh() {
      const data = this.filtersToData()
      if(!this.options.doNotCacheFilter) {
        this.$store.commit('setFiltersCache', { id: this.cacheKey, value: data })
      }
      this.$router.push({ path: this.$route.path, query: {
          filters: JSON.stringify(data)
        }
      }).catch(()=>{})
      if(window && window.innerWidth <= 768) {
        this.$refs?.['filter-wrapper-close']?.click()
      }
    },
    filtersToData() {
      let data = {}
      for(const f in this.filters) {
        let obj = this.filters[f]
        data[obj.id] = {
          id:           obj.id,
          condition:    obj.condition,
          type:         obj.ctype
        }
        if(obj.ctype === 'interval') {
          data[obj.id].conditionAdd = obj.conditionAdd || null
        }
      }
      this.$store.commit('setFilters', data)
      return data
    },
    removeFilter(id) {
      delete this.filters[id]
      this.refresh()
    },
    filterSelected(filter, condition = '', conditionAdd = '', ctype = null) {
      let meta = this.getOptions(filter.id)
      let id = filter.filter_field_id ?? filter.id
      let default_type = 'like'
      if(meta.type === 'select') { default_type = 'equals' }
      if(meta.type === 'select_equals') { default_type = 'equals' }
      if(meta.type === 'select_multiple') { default_type = 'contains' }
      if(meta.type === 'number') { default_type = 'equals' }
      if(meta.type === 'number_with_interval') { default_type = 'equals' }
      if(meta.type === 'date') { default_type = 'equals' }
      if(meta.type === 'date_with_interval') { default_type = 'equals' }
      if(meta.type === 'date_with_interval_no_year') { default_type = 'equals' }
      if(meta.type === 'text_with_interval') { default_type = 'equals' }
      if(meta.type === 'text_contains') { default_type = 'like' }
      if(meta.type === 'text_exact') { default_type = 'equals' }
      if(meta.type === 'service') { default_type = 'equals' }
      if(meta.type === 'time') { default_type = 'equals' }
      if(meta.type === 'boolean') {
        default_type = 'equals';
        if(condition != 1) { condition = 0; }
      }
      if(ctype) default_type = ctype
      this.filters[id] = {
        id:         id,
        title:      filter.title,
        condition:  condition,
        conditionAdd:  conditionAdd,
        translate:  meta.translate,
        type:       meta.type,
        ctype:      default_type,
        options:    meta.options
      }
      this.$bvModal.hide('filter-modal-'+this.viewModel)
    },
    addCondition() {
      if(!this.prepared) {
        this.prepare().then(this.$bvModal.show('filter-modal-'+this.viewModel))
      } else {
        this.$bvModal.show('filter-modal-'+this.viewModel)
      }
    },
    saveFilter() {
      this.$store.commit('incrementSaveFilterCounter')
    },
    prepare() {
      return new Promise(resolve => {
        EloquentService.prepare(this.viewModel, {}, this.superadmin).then(res => {
          this.prepared = true
          this.$store.commit("setSelectModels", Array.isArray(res.data.options) ? {} : res.data.options)
          resolve()
        })
      })
    },
    getOptions(id) {
      let res = {
        type: 'text'
      }
      this.options.fields.forEach(item => {
        if(item.id === id) {
          if(item.filter_list_select) {
            res = {
              type: 'select',
              translate: true,
              options: Object.values(item.filter_list_options || item.form.options)
            }
          }
          if(item.filter_list_select_equals) {
            res = {
              type: 'select_equals',
              translate: true,
              options: Object.values(item.form?.options || [])
            }
          }
          if(item.filter_list_select_multiple) {
            res = {
              type: 'select_multiple',
              translate: false,
              options: Object.values(item.filter_list_options || item.form.options)
            }
          }
          if(item.filter_model_select) {
            res = {
              type: 'select',
              translate: false,
              options: this.selectModels[id] ? this.selectModels[id] : []
            }
          }
          if(item.filter_model_select_equals) {
            res = {
              type: 'select_equals',
              translate: false,
              options: this.selectModels[id] ? this.selectModels[id] : []
            }
          }
          if(item.filter_model_select_translate) {
            res = {
              type: 'select',
              translate: true,
              options: this.selectModels[id] ? this.selectModels[id] : []
            }
          }
          if(item.filter_model_select_equals) {
            res = {
              type: 'select_equals',
              translate: false,
              options: this.selectModels[id] ? this.selectModels[id] : []
            }
          }
          if(item.filter_number) {
            res = {
              type: 'number'
            }
          }
          if(item.filter_number_with_interval) {
            res = {
              type: 'number_with_interval',
            }
          }
          if(item.filter_boolean) {
            res = {
              type: 'boolean'
            }
          }
          if(item.filter_date) {
            res = {
              type: 'date'
            }
          }
          if(item.filter_date_with_interval) {
            res = {
              type: 'date_with_interval'
            }
          }
          if(item.filter_date_with_interval_no_year) {
            res = {
              type: 'date_with_interval_no_year'
            }
          }
          if(item.filter_text_with_interval) {
            res = {
              type: 'text_with_interval'
            }
          }
          if(item.filter_text_contains) {
            res = {
              type: 'text_contains'
            }
          }
          if(item.filter_text_exact) {
            res = {
              type: 'text_exact'
            }
          }
          if(item.filter_time) {
            res = {
              type: 'time'
            }
          }
          if(item.filter_service) {
            res = {
              type: 'service'
            }
          }
        }
      })
      return res
    },
    getCTypes(type, id) {
      if(['date_from','date_to','task_date'].includes(id)) {
        return {
          'equals': { id: 'equals', title: 'equals' },
        }
      }
      switch(type) {
        case 'text':
          return {
            'equals': { id: 'equals', title: 'equals' },
            'does_not_equal': { id: 'does_not_equal', title: 'does_not_equal' },
            'like': { id: 'like', title: 'contains' },
            'not_like': { id: 'not_like', title: 'does_not_contain' },
            'filled': { id: 'filled', title: 'filled' },
          }
        case 'text_contains':
          return {
            'like': { id: 'like', title: 'contains' },
          }
        case 'text_exact':
          return {
            'equals': { id: 'equals', title: 'equals' },
            'does_not_equal': { id: 'does_not_equal', title: 'does_not_equal' },
            'filled': { id: 'filled', title: 'filled' },
          }
        case 'text_with_interval':
          return {
            'equals': { id: 'equals', title: 'equals' },
            'like': { id: 'like', title: 'contains' },
            'filled': { id: 'filled', title: 'filled' },
            'interval': { id: 'interval', title: 'in_interval' },
          }
        case 'select':
          return {
            'equals': { id: 'equals', title: 'equals' },
            'does_not_equal': { id: 'does_not_equal', title: 'does_not_equal' },
            'contains': { id: 'contains', title: 'contains' },
            'does_not_contain': { id: 'does_not_contain', title: 'does_not_contain' },
          }
        case 'select_multiple':
          return {
            'contains': { id: 'contains', title: 'contains' },
          }
        case 'number':
        case 'time':
        case 'date':
          return {
            'equals': { id: 'equals', title: 'equals' },
            'more': { id: 'more', title: 'more' },
            'less': { id: 'less', title: 'less' },
          }
        case 'number_with_interval':
        case 'date_with_interval':
        case 'date_with_interval_no_year':
          return {
            'equals': { id: 'equals', title: 'equals' },
            'more': { id: 'more', title: 'more' },
            'less': { id: 'less', title: 'less' },
            'interval': { id: 'interval', title: 'in_interval' },
          }
        case 'select_equals':
        case 'boolean':
          return {
            'equals': { id: 'equals', title: 'equals' },
          }
        case 'service':
          return {
            'equals': { id: 'equals', title: 'equals' },
            'like': { id: 'like', title: 'contains' },
          }
      }
    },
    showServiceSelect() {
      this.$refs?.serviceSelect?.selectFromPrice()
    },
    servicesSelected(services) {
      this.filters.service.condition = []
      this.filters.service.additionalData = []
      services.forEach(service => {
        if(this.filters.service && this.filters.service.type === 'service') {
          this.filters.service.condition.push(service.id)
          this.filters.service.additionalData.push(service)
          // this.filters.service.additionalData = service
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.filter-wrapper {
  padding: 16px 23px;
  border: 1px solid $gray-icon;
  background: $body-bg;
  border-radius: 5px;
  position: relative;
  .filter-wrapper-close {
    position: absolute;
    padding-right: 23px;
    padding-top: 21px;
    z-index: 2;
    cursor: pointer;
    right: 0;
    top: 0;
    svg {
      width: 14px;
      height: 14px;
      fill: $label-color;
    }
  }
}
.option-list-item {
  display: block;
  line-height: 42px;
  color: #000;
  cursor: pointer;
  padding: 0 15px;
  border-top: 1px solid $calendar-border-color;
  &:last-of-type {
    border-bottom: 1px solid $calendar-border-color;
  }
  &:hover {
    text-decoration: none;
    background: $light-blue;
  }
}
.filter-field {
  border: 1px solid $gray-icon;
  background: #fff;
  border-radius: 3px;
  .filter-title {
    color: $gray-text;
    font-size: 14px;
    padding-left: 15px;
    padding-right: 10px;
  }
  .filter-value {
    select, input {
      background-color: #ededed;
      border-radius: 5px;
    }
  }
  input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 16px;
    max-width: 90px;
    &.underlined {
      border-bottom: 1px solid $gray-icon;
    }
  }
  select {
    border: none;
    margin-right: 10px;
    outline: none;
    &.select-type {
      background: #E8F2FC;
      -webkit-appearance: none;
      -moz-appearance: none;
      text-transform: lowercase;
      padding: 3px;
      font-weight: 600;
      border-radius: 5px;
      line-height: 1rem;
    }
  }
  .filter-close {
    cursor: pointer;
    height: 38px;
    width: 38px;
    line-height: 36px;
    text-align: center;
    display: block;
    border-left: 1px solid $gray-icon;
    svg {
      width: 16px;
      height: 16px;
      fill: $gray-icon;
    }
  }
}
@media screen and (max-width: 768px) {
  .filter-collapse-general {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    .filter-wrapper-pb, .filter-wrapper {
      height: 100%;
    }
  }
  .filter-wrapper {
    padding-top: 0;
    border: none;
    .filter-wrapper-close {
      z-index: 2;
      position: relative;
      margin-bottom: 20px;
      border-bottom: 1px solid $gray-icon;
      padding: 15px 23px;
      //padding-top: 15px;
      //padding-bottom: 15px;
      display: block;
      background: #fff;
      margin-left: -23px;
      margin-right: -23px;
      span {
        margin-left: 15px;
        font-size: 15px;
        color: #000;
      }
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
  .refresh-btn {
    width: 100%;
    border-radius: 5px;
    margin-top: 28px;
    justify-content: center;
    height: 36px;
  }
  .filter-field {
    .filter-title {
      font-size: 12px;
    }
    .filter-close {
      height: 36px;
      width: 38px;
      line-height: 34px;
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
